import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import { DS_TAB_CHROME } from 'designSystem/util';
import { pathsToDsLinks } from 'designSystem/content/util';
import { DesignSystemSection, VALID_DESIGN_SYSTEM_SECTIONS } from 'designSystem/types';
import useDsNavigation from 'hooks/useDsNavigation';

// Mirrors how DsUpdateCard resolves its paths.
function resolveShowPath(
	path?: string
): { section: DesignSystemSection; contentPath?: string; label: string } | null {
	if (!path) return null;
	const section = path.split('/')[0] as DesignSystemSection;
	if (!VALID_DESIGN_SYSTEM_SECTIONS.includes(section)) return null;
	const links = pathsToDsLinks([path], section);
	const link = links[0];
	if (!link || link.deleted) return null;
	return { section, contentPath: link.contentPath, label: link.label };
}

interface Props {
	path?: string;
}

const ShowAction = ({ path }: Props) => {
	const { openTab } = useDsNavigation();
	const target = resolveShowPath(path);

	const chrome = target ? DS_TAB_CHROME[target.section] : null;
	const icon = chrome?.icon ?? IconType.FRAME;
	const label = target ? `View ${target.label}` : 'Open in design system';

	const onClick = () => {
		if (target) openTab(target.section, target.contentPath);
	};

	return <ActionButton icon={icon} label={label} onClick={onClick} />;
};

export default ShowAction;
